export default __webpack_public_path__ + "locales/sq-AL/SalesDepartmentRequestDialog.json?hash=5c2befe5c6b40d9dc1813415dc66aac3";